import { FeedData } from 'shared/models';
import { atom, PrimitiveAtom } from 'jotai';
import { pendingQueue } from 'shared/utils/pending-queue';
import { safeAtomFamily } from 'shared/utils/safe-atom-family';

type FeedStore = { [key: string]: Promise<FeedData> | FeedData | undefined };

export const $FeedDataStore: PrimitiveAtom<FeedStore> = atom<FeedStore>({});
$FeedDataStore.debugLabel = '$FeedDataStore';

export const $FeedData = safeAtomFamily((categoryName: string) => {
  const a = atom(
    (get) => {
      const data = get($FeedDataStore)[categoryName];
      if (!data) {
        // eslint-disable-next-line @typescript-eslint/no-throw-literal
        throw new Promise<void>((resolve) => pendingQueue.push(() => resolve()));
      }

      return data;
    },
    (get, set, nextCategoryData: Promise<FeedData> | FeedData) => {
      const old: FeedStore = get($FeedDataStore);

      set($FeedDataStore, {
        ...old,
        [categoryName]: nextCategoryData,
      });

      if (nextCategoryData instanceof Promise) {
        nextCategoryData
          .then((data) => {
            set($FeedDataStore, {
              ...old,
              [categoryName]: data,
            });
          })
          .catch(() => {
            set($FeedDataStore, {
              ...old,
              [categoryName]: void 0,
            });
          });
      }
    },
  );

  a.debugLabel = `$FeedData+${encodeURIComponent(categoryName)}`;

  return a;
});

export const $FeedDateLoadmore = safeAtomFamily((categoryName: string) => {
  const a = atom(null, async (get, set, input: FeedData) => {
    const { minBeHotTime, items } = await get($FeedData(categoryName));
    const { maxBeHotTime, hasMore, items: nextItems } = input;

    set($FeedData(categoryName), {
      items: [...items, ...nextItems],
      minBeHotTime,
      maxBeHotTime,
      hasMore,
    });
  });

  a.debugLabel = `$FeedDateLoadmore+${encodeURIComponent(categoryName)}`;

  return a;
});
